import { Button, Container, Typography } from '@pwskills/rachnaui';
import React, { useContext, useState } from 'react';
import CommunityImg from '@/assets/icons/categoryPage/Community.svg';
import Image from 'next/image';
import CategoryPageContext from '../../../context/CategoryPageContext';
import LeadCapture from '../../common/LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../interfaces/leadCapture.enum';

const LearnersCommunity = () => {
  const [openModal, setOpenModal] = useState(false);
  const { categoryDetails } = useContext(CategoryPageContext);
  const communityDetails = categoryDetails?.community;

  return (
    <section className="medium:!bg-white">
      <Container className=" py-8 medium:pt-14 medium:pb-[52px] medium:!px-8 large:!px-20 flex flex-col gap-6 bg-white">
        <div className="flex flex-col large:!flex-row justify-between">
          <div className="flex flex-col justify-center gap-6 w-full large:!w-[702px]">
            <div className="flex flex-col large:!gap-3 leading-[60px]">
              <Typography
                component="h2"
                variant="bold"
                className="text-[#B5BBC5] font-inter medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
              >
                Get More
              </Typography>
              <Typography
                component="h2"
                variant="bold"
                className="text-gray-850 font-inter medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
              >
                Join Our Learners Community
              </Typography>
            </div>

            <div>
              <Typography
                component="body-regular"
                variant="regular"
                className="text-[#3D3D3D] !text-[16px] text-center medium:!text-left"
              >
                {communityDetails?.description}
              </Typography>
            </div>

            <div className="flex items-center justify-center large:!justify-start">
              <Button
                variant="primary"
                size="medium"
                className="bg-[#E97862] text-white !px-[40px] !py-2 !rounded"
                onClick={() => setOpenModal(true)}
              >
                Join Now
              </Button>
            </div>
          </div>

          {openModal && (
            <LeadCapture
              leadCaptureType={LeadCaptureType.MODAL}
              categoryId={categoryDetails?._id}
              categoryName={categoryDetails?.title}
              modelOpen={openModal}
              setModelOpen={setOpenModal}
              buttonText="Join Community"
              img="/images/courseDescription/get-in-touch.svg"
              msgLineOne="You will be redirected to the "
              msgLineTwo="invite link"
              type="AlumniConnect"
              enquiryType={LeadCaptureEnquiryType.JOIN_COMMUNITY}
              enquiryTypeNPF="Join Community"
              redirectLink={communityDetails?.inviteLink}
              pageName="category_page"
              sourceName="category_learners_community"
            />
          )}

          <div className="flex items-center justify-center mt-6 medium:!mt-14 large:!mt-0">
            <Image
              src={CommunityImg}
              alt="categoryImg"
              width={464}
              height={464}
              className="w-[328px] medium:!w-[464px]"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default LearnersCommunity;
